import { ButtonProps } from "@chakra-ui/react";
import { User } from "features/User/models";
import { useIsCurrentUserCompanyAdmin } from "hooks/useCurrentUserPermissions";
import UpdateRolesForm from "components/Forms/UpdateRolesForm";
import ModalFormWrapper from "components/ModalForm/ModalFormWrapper";

interface UpdateRolesButtonProps extends ButtonProps {
  user: User;
  isAdmin?: boolean;
  onSuccess?: (resp: any) => void;
}


export function UpdateRolesModalButton({ children, isAdmin = false, user, onSuccess }: UpdateRolesButtonProps) {
  const isCompanyAdmin = useIsCurrentUserCompanyAdmin();

  if (!isCompanyAdmin && !isAdmin) return null;

  return (
    <ModalFormWrapper
      modalHeader="Update Roles"
      button={children}
    >
      <UpdateRolesForm user={user} onSuccess={onSuccess} />
    </ModalFormWrapper>
  );
}
